import { appInfo } from "@/common/data/appinfo";

export default [
  {
    path: "/f5s9cvnO9vRULCR45r2N",
    children: [
      {
        path: "",
        component: () => import("@/views/semester/index.vue"),
        name: "semester-list",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "Term" : "Semester",
          acc: ["y40294"],
        },
      },
      {
        path: "Ve1Gbjrsgy",
        component: () => import("@/views/semester/create.vue"),
        name: "create-semester",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "Create Term" : "Create Semester",
          acc: ["y82905"],
        },
      },
      {
        path: "z8anhG1LJb",
        component: () => import("@/views/semester/edit.vue"),
        name: "edit-semester",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "Edit Term" : "Edit semester",
          acc: ["y10849"],
        },
      },
      {
        path: "z8anhG1LJb/r",
        component: () => import("@/views/semester/view.vue"),
        name: "view-semester",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "View Term" : "View Semester",
          acc: ["y27202"],
        },
      },
    ],
  },
];
